import React, { FunctionComponent } from 'react';

import styled, { css } from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import CircleRightArrowIcon from '@components/basics/icons/circle-right-arrow';

interface BlueHintProps {
  className?: string;
  isActive?: boolean;
  hasArrow?: boolean;
  hasMarginTop?: boolean;
  onClick?: () => void;
}

const BlueHint: FunctionComponent<BlueHintProps> = ({
  className,
  children,
  isActive,
  hasArrow,
  onClick,
}) => {
  return (
    <Flex
      className={`${className || ''} ${isActive ? 'is-active' : ''}`}
      alignItems="center"
      justifyContent={hasArrow ? 'space-between' : 'flex-start'}
    >
      <Typography className="blue-hint-text" type="small" weight="700">
        {children}
      </Typography>
      {hasArrow && <CircleRightArrowIcon isWhite size={24} onClick={onClick} />}
    </Flex>
  );
};

export default styled(BlueHint)`
  padding: 10px 30px;
  border-radius: 0 0 10px 10px;
  background-color: ${({ theme }) => theme.colors.blueColor};
  transition: background-color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`},
    color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

  ${(props) =>
    props.hasMarginTop
      ? css`
          margin-top: 3px;
        `
      : null}

  .blue-hint-text {
    color: ${({ theme }) => theme.colors.white};
  }

  &.is-active {
    background-color: ${({ theme }) => theme.colors.primary};
    .blue-hint-text {
      color: ${({ theme }) => theme.colors.differentBackground};
    }
  }
`;
